'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidSettings = function IoAndroidSettings(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.1 21.6l3.7 2.7c0.2 0.2 0.3 0.8 0.1 1.1l-3.3 5.5c-0.2 0.4-0.6 0.6-1 0.4l-4.2-1.6c-0.9 0.6-1.8 1.2-2.8 1.6l-0.6 4.3c-0.1 0.3-0.5 0.7-0.9 0.7h-6.6c-0.4 0-0.8-0.3-0.9-0.7l-0.6-4.3c-1-0.4-2-1-2.8-1.6l-4.2 1.6c-0.4 0.2-0.8 0-1-0.4l-3.3-5.5c-0.3-0.4-0.2-0.9 0.1-1.1l3.5-2.7c0-0.5 0-1.1 0-1.6s0-1.1 0-1.6l-3.6-2.7c-0.2-0.2-0.3-0.8-0.1-1.1l3.3-5.5c0.2-0.4 0.6-0.6 1-0.4l4.2 1.6c0.9-0.6 1.8-1.2 2.8-1.6l0.6-4.3c0.1-0.3 0.5-0.7 0.9-0.7h6.6c0.4 0 0.8 0.4 0.9 0.7l0.5 4.3c1.1 0.4 2 1 2.9 1.6l4.1-1.6c0.3-0.2 0.9 0 1 0.4l3.4 5.5c0.2 0.4 0.1 0.9-0.2 1.1l-3.5 2.7c0 0.5 0.1 1.1 0.1 1.6s0 1.2-0.1 1.6z m-12.4 4.1c3.2 0 5.8-2.5 5.8-5.7s-2.6-5.7-5.8-5.7-5.8 2.5-5.8 5.7 2.6 5.7 5.8 5.7z' })
        )
    );
};

exports.default = IoAndroidSettings;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-settings.js
// module id = 1906
// module chunks = 0